// extracted by mini-css-extract-plugin
export default {"content":"ChangedEmailPopup_content__-XwNEnjd"};